// local
import { showNotification } from './notification-message.action';
import { clearAndRedirect } from './auth.action';

export default function(dispatch, error, action = null) {
    const statusCode = error.statusCode;
    switch (statusCode) {
        case 401:
            clearAndRedirect(dispatch);
            break;
        case 403:
        case 500:
            dispatch(showNotification([{ key: `error_${statusCode}` }]));
            break;
        default:
            if (typeof action === 'function') {
                action();
            } else if (action) {
                dispatch(showNotification(error.errors));
            }
            break;
    }
}
